"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "proceduresReducer", {
  enumerable: true,
  get: function get() {
    return _duck.default;
  }
});
Object.defineProperty(exports, "getProcedureResult", {
  enumerable: true,
  get: function get() {
    return _selectors.getProcedureResult;
  }
});
Object.defineProperty(exports, "configureIguazuRPC", {
  enumerable: true,
  get: function get() {
    return _config.configureIguazuRPC;
  }
});
Object.defineProperty(exports, "setProcedures", {
  enumerable: true,
  get: function get() {
    return _setProcedures.default;
  }
});
Object.defineProperty(exports, "queryProcedureResult", {
  enumerable: true,
  get: function get() {
    return _query.default;
  }
});
Object.defineProperty(exports, "clearProcedureResult", {
  enumerable: true,
  get: function get() {
    return _clear.default;
  }
});

var _duck = _interopRequireDefault(require("./duck"));

var _selectors = require("./duck/selectors");

var _config = require("./config");

var _setProcedures = _interopRequireDefault(require("./setProcedures"));

var _query = _interopRequireDefault(require("./useProcedureResult/query"));

var _clear = _interopRequireDefault(require("./useProcedureResult/clear"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }